<template>
    <div>
        
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <div class="mx-auto container container--fluid">
            <v-app id="inspire">
                <v-card class="box">
                    <template v-if="load == true">
                        <!-- <v-row justify="center">
                            <v-col class="12" md="3" sm="4" v-for="i,index in ay_list" :key="index">
                                <v-card>
                                    <v-toolbar flat dense :class="i.isactive ? 'active_class' : 'toolbar'">
                                        <v-toolbar-title>{{i.ay}}</v-toolbar-title>
                                        <v-divider class="mx-4" inset vertical></v-divider>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-col cols="12" sm="12" md="12">
                                        Sort Order - {{i.sort_order}} <br />
                                        Display Name - {{i.displayname}} <br />
                                        Shortcut - {{i.shortcut}} <br />
                                        Previous AY - {{i.prevay}} <br />
                                        Next AY - {{i.nextay}} <br />
                                        <v-switch dense hide-details color="#0F2027" label="Is Active ?" v-model="i.isactive"></v-switch>
                                        <v-switch dense hide-details label="Is-ERP ?" color="#0F2027" v-model="i.isinerp"></v-switch>
                                        <v-switch dense hide-details color="#0F2027" label="Is-Active for Admission Form ? " v-model="i.isactiveforadmissionform"></v-switch>
                                        <v-switch dense hide-details color="#0F2027" label="Hide In Account Report " v-model="i.hide_in_account_report"></v-switch>
                                        <v-switch dense hide-details color="#0F2027" label="Is Freezed For Communication ?" v-model="i.is_freezed_for_communication"></v-switch>
                                    </v-col>
                                </v-card>
                            </v-col>
                        </v-row> -->
                        <v-data-table :headers="headers" :items="ay_list" class="elevation-1 mytable" :search="search"
                            dense :items-per-page="-1">
                            <template v-slot:top>
                                <v-toolbar flat dense class="toolbar">
                                    <v-toolbar-title>Academic Year</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                                <span style="width: 20px;"></span>
                                <v-dialog v-model="dialog" max-width="500px">
                                    <template v-slot:activator="{ on }">
                                        <v-toolbar flat dense>
                                            <v-toolbar-title>
                                                <!-- <v-btn class="mb-2 button" v-on="on" :disabled="isallowed == false ? true : false">New Academic Year</v-btn> -->
                                                <v-btn class="mb-2 button" v-on="on"
                                                    :disabled="isallowed == false ? true : false"
                                                    @click="iseditable = !iseditable">New Academic Year</v-btn>
                                            </v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-text-field v-model="search" append-icon="search" label="Search"
                                                single-line hide-details> </v-text-field>
                                        </v-toolbar>
                                    </template>
                                    <v-card>
                                        <v-card-title class="toolbar">
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.ay" label="Academic Year"
                                                            dense hint="For example :: 2018-19"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.sort_order" type="number"
                                                            label="SortOrder " dense
                                                            hint="For example :: 1,2,3"></v-text-field>
                                                    </v-col>

                                                    <v-col>
                                                        <input type="hidden" v-model="editedItem.id" label="id"
                                                            name="id" />
                                                    </v-col>
                                                </v-row>

                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.displayname"
                                                            label="Display Name" dense
                                                            hint="For example :: 2018"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row v-if="editedIndex != -1">
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.exam_displayname"
                                                            label=" Exam Display Name" hint="For example :: 2024-25"
                                                            dense single-line></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row dense>
                                                    <v-col cols="12">
                                                        <v-text-field v-model="editedItem.shortcut"
                                                            label="Short Cut    " dense
                                                            hint="Short Cut :: 18"></v-text-field>
                                                    </v-col>
                                                </v-row>

                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-select dense v-model="editedItem.prevay" :items="ay_list"
                                                            item-text="ay" item-value="id"
                                                            label="Previous Academic Year" persistent-hint :hint="editedIndex == -1
                                                                ? 'Select AY :: 2017-18 etc'
                                                                : 'noneditable'
                                                                " :disabled="editedIndex != -1"
                                                            :filled="iseditable ? false : true" return-object
                                                            single-line></v-select>
                                                    </v-col>
                                                    <v-col cols="12">
                                                        <v-select dense v-model="editedItem.nextay" :items="ay_list"
                                                            item-text="ay" item-value="id" label="Next Academic Year"
                                                            persistent-hint return-object single-line></v-select>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                            label="Is-Active?"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-checkbox dense v-model="editedItem.isinerp" color="success"
                                                            label="Is In ERP?"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-checkbox dense v-model="editedItem.isactiveforadmissionform"
                                                            color="success"
                                                            label="Is-Active for Admission Form?"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-checkbox dense v-model="editedItem.hide_in_account_report"
                                                            color="success" label="Hide In Account Report"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-checkbox dense v-model="editedItem.is_freezed_for_accounts"
                                                            color="success"
                                                            label="Is Freezed For Accounts ?"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-checkbox dense
                                                            v-model="editedItem.is_freezed_for_communication"
                                                            color="success"
                                                            label="Is Freezed For Communication ?"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                                <v-row>
                                                    <v-col cols="12">
                                                        <v-checkbox dense v-model="editedItem.isinerp_for_examination"
                                                            color="success"
                                                            label="Is In Erp For Examination ?"></v-checkbox>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn class="button" @click="close">Cancel</v-btn>
                                            <v-btn class="button" @click="save">Save</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </template>
                            <template v-slot:item.isactive="{ item }">
                                <!-- <span v-if="item.isactive">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span> -->
                                <v-switch @change="saveAyFlag(item.isactive, 'isactive', item.id)" dense hide-details
                                    v-model="item.isactive" color="brand"></v-switch>
                            </template>
                            <template v-slot:item.isinerp="{ item }">
                                <!-- <span v-if="item.isinerp">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span> -->
                                <v-switch @change="saveAyFlag(item.isinerp, 'isinerp', item.id)" dense hide-details
                                    v-model="item.isinerp" color="brand"></v-switch>
                            </template>
                            <template v-slot:item.isactiveforadmissionform="{ item }">
                                <!-- <span v-if="item.isactiveforadmissionform">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span> -->
                                <v-switch
                                    @change="saveAyFlag(item.isactiveforadmissionform, 'isactiveforadmissionform', item.id)"
                                    dense hide-details v-model="item.isactiveforadmissionform" color="brand"></v-switch>
                            </template>
                            <template v-slot:item.hide_in_account_report="{ item }">
                                <!-- <span v-if="item.hide_in_account_report">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span> -->
                                <v-switch dense
                                    @change="saveAyFlag(item.hide_in_account_report, 'hide_in_account_report', item.id)"
                                    hide-details v-model="item.hide_in_account_report" color="brand"></v-switch>
                            </template>
                            <template v-slot:item.action="{ item }">
                                <v-avatar style size="25" class="edit-avatar">
                                    <v-icon class="edit-v-icon mr-2" @click="editItem(item)" title="edit"
                                        style>edit</v-icon>
                                </v-avatar>
                            </template>
                            <template v-slot:item.is_freezed_for_accounts="{ item }">
                                <!-- <span v-if="item.is_freezed_for_accounts">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span> -->
                                <v-switch dense
                                    @change="saveAyFlag(item.is_freezed_for_accounts, 'is_freezed_for_accounts', item.id)"
                                    hide-details v-model="item.is_freezed_for_accounts" color="brand"></v-switch>
                            </template>
                            <template v-slot:item.is_freezed_for_communication="{ item }">
                                <!-- <span v-if="item.is_freezed_for_communication">
                                    <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                                </span>
                                <span v-else>
                                    <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                                </span> -->
                                <v-switch
                                    @change="saveAyFlag(item.is_freezed_for_communication, 'is_freezed_for_communication', item.id)"
                                    dense hide-details v-model="item.is_freezed_for_communication" color="brand"></v-switch>
                            </template>
                            <template v-slot:item.isinerp_for_examination="{ item }">

                                <v-switch
                                    @change="saveAyFlag(item.isinerp_for_examination, 'isinerp_for_examination', item.id)"
                                    dense hide-details v-model="item.isinerp_for_examination" color="brand"></v-switch>
                            </template>
                        </v-data-table>
                    </template>
                </v-card>
            </v-app>
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
    data: () => ({
        
        overlay: false, isallowed: false,
       
        errorMsg: {
            ay: false,
        },
        iseditable: false,
        load: false,
        dialog: false,
        ay_list: null,
        // field_type_list:null,
        // field_list:null,
        search: "",
        snackbar_msg: "",
        color: "",
        snackbar: false,
        headers: [
            { text: "Academic Year", value: "ay" },
            // { text: "Display Name", value: "displayname" },
            { text: "Sort Order", value: "sort_order" },
            // { text: "Shortcut", value: "shortcut" },
            // { text: "Previous AY", value: "prevay.ay" },
            // { text: "Next AY", value: "nextay.ay" },
            { text: "Is-Active?", value: "isactive" },
            { text: "Is-ERP?", value: "isinerp" },
            {
                text: "Is-Active for Admission Form?",
                value: "isactiveforadmissionform",
                align: "center",
            },
            {
                text: "Hide In Account Report",
                value: "hide_in_account_report",
                align: "center",
            },
            {
                text: "Is Freezed For Accounts ?",
                value: "is_freezed_for_accounts",
                align: "center",
            },
            {
                text: "Is Freezed For Communication ?",
                value: "is_freezed_for_communication",
                align: "center",
            },
            {
                text: "Is In Erp For Examination ?",
                value: "isinerp_for_examination",
                align: "center",
            },
            { text: "Actions", value: "action", sortable: false },
        ],

        editedIndex: -1,
        editedItem: {
            id: 0,
            ay: "",
            displayname: "",
            exam_displayname: "",
            isactive: "",
            shortcut: "",
            prevay: "",
            nextay: "",
            sort_order: "",
            isactiveforadmissionform: "",
            hide_in_account_report: "",
            is_freezed_for_accounts: "",
            is_freezed_for_communication: "",
            isinerp_for_examination: "",
            isinerp: "",
        },
        defaultItem: {
            id: 0,
            ay: "",
            displayname: "",
            exam_displayname: "",
            isactive: "",
            shortcut: "",
            prevay: "",
            nextay: "",
            sort_order: "",
            isactiveforadmissionform: "",
            hide_in_account_report: "",
            is_freezed_for_accounts: "",
            is_freezed_for_communication: "",
            isinerp_for_examination: "",
            isinerp: "",
        },
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "New Academic Year" : "Edit Academic Year";
        },
    },

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        },
    },
    mounted() {
        this.onLoad();
    },

    methods: {
        saveAyFlag(flag, type, id) {
            // alert("flag::::"+flag)
            // alert("type::::"+type)
            // alert("id::::"+id)
            const data = {
                flag: flag,
                type: type,
                id: id
            };
            axios
                .post("/AdmissionMaster/saveAyFlag", data)
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.showSnackbar("#4caf50", "Academic Year Updated Successfully..."); // show snackbar on success
                        this.onLoad();
                    } else {
                        this.showSnackbar("#b71c1c", "Something went wrong!!!");
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    window.console.log(error);
                })
                .finally(() => { });
        },
        onLoad() {
            this.overlay = true;
            axios
                .post("/AdmissionMaster/academicYearFieldConfig")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        if ((this.load = true)) {
                            this.overlay = false;
                            this.ay_list = res.data.ay_list;
                            this.isallowed = res.data.isallowed
                        }
                    } else if (res.data.flag == "No") {
                        this.showSnackbar("red", res.data.snackbar);
                        this.isallowed = res.data.isallowed
                        this.overlay = false;
                        this.load = true;
                        this.isallowed = res.data.isallowed
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    window.console.log(error);
                })
                .finally(() => {
                    "use strict";
                    var overlay = false;
                });
        },
        initializeErrorMsgFalse() {
            this.errorMsg.standard = false;
        },
        editItem(item) {
            this.iseditable = false;
            this.editedIndex = this.ay_list.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            this.initializeErrorMsgFalse();
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        save() {
            // for(var i = 0;i < this.ay_list.length;i++){
            //     if(this.ay_list[i].sort_order == this.editedItem.sort_order){
            //         this.showSnackbar("#b71c1c", "Sort order should be unique");
            //         return
            //     }
            // }
            if (this.editedIndex > -1) {
                if (this.isValidated()) {
                    //  console.log("edit.." + this.editedItem);
                    this.iseditable = false;
                    axios
                        .post("/AdmissionMaster/editAcademicYearFormFieldConfig", this.editedItem)
                        .then((res) => {
                            if (res.data.msg == "200") {
                                Object.assign(this.ay_list[this.editedIndex], this.editedItem);
                                this.showSnackbar("#4caf50", "Academic Year Updated Successfully..."); // show snackbar on success
                                this.onLoad();
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });

                    this.close();
                }
            } else {
                if (this.isValidated()) {
                    axios
                        .post("/AdmissionMaster/saveAcademicYearFieldConfig", this.editedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                this.ay_list.push(this.editedItem);
                                this.showSnackbar("#4caf50", "Academic Year Added Successfully!!!"); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                this.showSnackbar("#b71c1c", "Academic Year Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                }
                this.close();
            }
        },
        isValidated() {
            if (this.editedItem.ay) {
                return true;
            } else {
                if (!this.editedItem.ay) {
                    this.errorMsg.ay = true;
                }

                return false;
            }
        }, // .....end of isValidated()
    },
};
</script>
<style scoped>
.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}

.v-icon-size {
    font-size: 20px;
}

.edit-avatar {
    transition: 0.3s;
    border: 1px solid #b0bec5;
}

.edit-avatar:hover {
    background-color: #b0bec5;
}

.edit-v-icon {
    padding-left: 6px;
    font-size: 15px;
}

.edit-v-icon:hover {
    color: white;
}

.mytable2 /deep/ thead th {
    background: #0f2027 !important;
    /* fallback for old browsers */
    background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* Chrome 10-25, Safari 5.1-6 */
    background: linear-gradient(to right, #2c5364, #203a43, #0f2027) !important;
    /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
    background-color: #0f2027 !important;
    color: white !important;
    font-weight: bold !important;
    white-space: nowrap !important;
    text-align: center;
}

.inactive_class {
    background: white !important;
}

.active_class {
    background: rgb(199, 199, 215) !important;
}
  
</style>
